import { useContext } from "react";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import UpdateHistoryContext from "context/UpdateHistoryContext";
import BRSFormsUploads from "./BRSFormsUpload";

const BRSForms = ({ handleGoBack, handleGoForward }) => {
  const { transactions } = useContext(UpdateHistoryContext);

  if (transactions?.length > 0) {
    return (
      <BRSFormsUploads
        transactions={transactions}
        handleGoBack={handleGoBack}
        handleGoForward={handleGoForward}
      />
    );
  }

  return (
    <div className="flex justify-center p-5 bg-white w-full h-40">
      <SpinnerIcon />
    </div>
  );
};

export default BRSForms;
